import { createSelector } from "@ngrx/store";
import * as fromElements from "./elements.reducer";
import { DataAccessElementsState, getDataAccessElementsState } from "./elements.state";

export const getElementsState = createSelector(getDataAccessElementsState, (state: DataAccessElementsState) => state.elements);
export const getElementEntities = createSelector(getElementsState, fromElements.getEntities);
export const getElementIds = createSelector(getElementsState, fromElements.getIds);
export const getAllElements = createSelector(getElementsState, fromElements.getAll);
export const getSelectedElementId = createSelector(getElementsState, fromElements.getSelectedId);
export const getSelectedElement = createSelector(getElementsState, fromElements.getSelected);
export const selectElement = (id: string) => createSelector(getElementEntities, (entities) => entities[id]);
